import removeMd from "remove-markdown";

const GLOSSARY_ITEM_TYPE = {
  VALUE: "value",
  TITLE: "title",
};

function fetchGlossaryListParams(params) {
  const defaultParams = {
    category: "recpR5YrmA7YixItg", // All Categories ID from Airtable
    search: "", // Setting the search keyword as blank to get all the data from Airtable
  };
  return { ...defaultParams, ...params };
}

function getSearchedDataList(DATA_LIST, params, fetchParams) {
  const searchResults = DATA_LIST.filter((listItem) => {
    let isCategoryValid = true;
    if (fetchParams.category) {
      isCategoryValid = listItem.categories.includes(fetchParams.category);
    }
    return isCategoryValid;
  });
  return searchResults;
}
function sortDataList(searchResults) {
  const sortedDataList = searchResults.sort((first, second) => {
    if (
      removeMd(first.title).toUpperCase() ===
      removeMd(second.title).toUpperCase()
    )
      return 0;
    else if (
      removeMd(first.title).toUpperCase() > removeMd(second.title).toUpperCase()
    )
      return 1;
    else return -1;
  });
  return sortedDataList;
}

function makeGroupedGlossaryList(glossaryList) {
  const { list } = glossaryList.reduce(
    ({ category, list }, listItem, index) => {
      const firstLetter = removeMd(listItem.title)
        .substring(0, 1)
        .toUpperCase();
      if (firstLetter === category) {
        list.push({ ...listItem, type: GLOSSARY_ITEM_TYPE.VALUE });
      } else {
        category = firstLetter;
        list.push({
          type: GLOSSARY_ITEM_TYPE.TITLE,
          title: firstLetter,
          id: `${index}_${firstLetter}`,
        });
        list.push({
          ...listItem,
          type: GLOSSARY_ITEM_TYPE.VALUE,
        });
      }
      return { category, list };
    },
    { category: null, list: [] }
  );
  return list;
}

/**
 * Get the glossary list to display in the glossary component
 * Pass the function that is present in AirtableUtils.js if present
 * or make another function
 */
export function getGlossaryListWithAirtable(getDataList, url, apiKey, project) {
  return (params) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const fetchParams = fetchGlossaryListParams(params);
      const dataList = await getDataList(url, apiKey, params.search, project);
      const searchResults = getSearchedDataList(dataList, params, fetchParams);
      const finalData = makeGroupedGlossaryList(sortDataList(searchResults));
      resolve(finalData);
    });
  };
}

/**
 * This is to fetch individual items from Airtable
 * by passing the fetch function, url, apiKey and the ID
 * for the item that needs to be fetched
 */
export function getIndividualGlossaryItem(fetchData, url, apiKey) {
  return (glossaryId) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const dataItem = await fetchData(url, apiKey, glossaryId);
      resolve(dataItem);
    });
  };
}
